export default {"src":"/_next/static/image/public/images/ic_dot.52e7ee1ccf539e4001bfd54439295ec2.svg","height":6,"width":12};